import headerImgEn from "assets/images/v122/header-en.webp"
import infoImgEn from "assets/images/v122/info-en.webp"

export const v122ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
